var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"appFooterStatic"}},[_vm._m(0),_c('Redes',{attrs:{"links":_vm.redes.links,"textoRedes":_vm.redes.txt,"hashtag":_vm.redes.hashtag}}),_c('Copyright')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleFoo"},[_vm._v("SATE - Sindicato Argentino "),_c('br'),_vm._v("de Técnicos Escénicos")])
}]

export { render, staticRenderFns }